export default "__VITE_ASSET__CGhXWvgX__"